// reducer.ts
export type Source = 'user-scroll' | 'programmatic' | 'header' | null

export interface TimelineState {
  offsetX: number
  originalOffset: number
  touched: boolean
  dateDisplayed: Date
  source: Source
  days: string[]
}

export type TimelineAction =
  | { type: 'INIT'; payload: { offsetX: number; dateDisplayed: Date } }
  | { type: 'SCROLL_USER'; payload: { offsetX: number } }
  | { type: 'SCROLL_PROGRAMMATIC'; payload: { offsetX: number } }
  | { type: 'SET_TOUCHED'; payload: boolean }
  | { type: 'SNAP_TO_ORIGINAL' }
  | { type: 'SET_DATE_FROM_HEADER'; payload: { date: Date } }
  | { type: 'SET_ORIGINAL_OFFSET'; payload: number }
  | { type: 'SET_OFFSET_PROGRAMMATIC_CHANNEL'; payload: number }
  | { type: 'SET_SOURCE'; payload: Source }

const DAY_WIDTH_PX = 9600

export function timelineReducer(
  state: TimelineState,
  action: TimelineAction
): TimelineState {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        offsetX: action.payload.offsetX,
        originalOffset: action.payload.offsetX,
        dateDisplayed: action.payload.dateDisplayed,
        source: 'programmatic',
      }
    case 'SCROLL_USER':
      if (Math.round(state.offsetX) === Math.round(action.payload.offsetX))
        return state

      return {
        ...state,
        offsetX: action.payload.offsetX,
        source: 'user-scroll',
        dateDisplayed: new Date(
          state.days[
            Math.max(
              0,
              Math.min(
                state.days.length - 1,
                Math.floor(action.payload.offsetX / DAY_WIDTH_PX)
              )
            )
          ]
        ),
      }
    case 'SCROLL_PROGRAMMATIC':
      if (Math.round(state.offsetX) === Math.round(action.payload.offsetX))
        return state

      return {
        ...state,
        offsetX: action.payload.offsetX,
        source: 'programmatic',
        dateDisplayed: new Date(
          state.days[
            Math.max(
              0,
              Math.min(
                state.days.length - 1,
                Math.floor(action.payload.offsetX / DAY_WIDTH_PX)
              )
            )
          ]
        ),
      }
    case 'SET_OFFSET_PROGRAMMATIC_CHANNEL': {
      return {
        ...state,
        offsetX: action.payload,
        source: 'programmatic',
      }
    }
    case 'SET_TOUCHED':
      return { ...state, touched: action.payload }
    case 'SET_SOURCE':
      return { ...state, source: action.payload }
    case 'SET_DATE_FROM_HEADER':
      return {
        ...state,
        dateDisplayed: action.payload.date,
        source: 'header',
      }
    case 'SET_ORIGINAL_OFFSET':
      return { ...state, originalOffset: action.payload }
    default:
      console.error('Unknown action type:', action)
      return state
  }
}
